import { AUTHORFILTER, CATEGORYFILTER, TITLEFILTER } from "./actionIdentifier";
import initialState from "./initialState";

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORYFILTER:
      if (state.category.includes(action.payload)) {
        return {
          ...state,
          category: state.category.filter((element) => element !== action.payload),
        };
      } else {
        return {
          ...state,
          category: [...state.category, action.payload],
        };
      }
    case AUTHORFILTER:
      if (state.author.includes(action.payload)) {
        return {
          ...state,
          author: state.author.filter((element) => element !== action.payload),
        };
      } else {
        return {
          ...state,
          author: [...state.author, action.payload],
        };
      }
    case TITLEFILTER:
      return {
        category: [],
        author: [],
        titleFilter: action.payload,
      };
    default:
      return state;
  }
};

export default filterReducer;
